import { openEmailSubOrderModal } from '../../../State/emailSubOrderModal'

export default () => (dispatch, getState) => {

  const { subOrder } = getState().screens.SubOrder

  // Open email modal with SSO URL placeholder and lock the To field
  dispatch(openEmailSubOrderModal({
    initialBody: `Dear ${subOrder.subcontractor.name}\r\n\r\nPlease find attached Purchase Order for ${subOrder.project_id}.\r\n\r\nClick here to approve: {{sso_url}}\r\n\r\nKind Regards\r\n\r\n${subOrder.user.first_name} ${subOrder.user.last_name}`,
    lockToField: true,
  }))

}
